export enum TipoPerfil {
  FRONTERA = 'Perfil con énfasis en investigación de ciencia básica y de frontera',

  SOCIOAMBIENTAL = 'Perfil con énfasis en investigación para la incidencia socioambiental',

  TECNOLOGICA = 'Perfil con énfasis en desarrollo tecnológico e innovación',
}
